import React from 'react'

const Docker = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 184 128" {...props}>
    <path
      fill="#0DB7ED"
      d="M105.006 58.635h18.779V41.39h-19.162l.383 17.245zm-22.611 0h18.779V41.39H82.395v17.245zm-22.611 0h19.162V41.39H59.784v17.245zm-22.61 0h19.162V41.39H37.174v17.245zm-22.611 0h19.162V41.39H14.946l-.383 17.245zM37.174 37.94h19.162V20.695H37.174V37.94zm22.61 0h19.162V20.695H59.784V37.94zm22.611 0h18.779V20.695H82.395V37.94zm0-20.695h18.779V0H82.395v17.245zm98.491 31.426c-4.216-2.683-13.796-3.832-21.078-2.299-1.15-6.898-4.982-13.03-11.88-18.395l-3.832-2.683-2.683 4.216c-3.449 4.982-5.365 12.264-4.599 19.162.383 2.299 1.15 6.515 3.449 10.347-2.299 1.533-7.281 3.066-13.796 3.066H1.15l-.383 1.533c-1.15 6.898-1.15 28.743 12.647 45.221 10.73 12.647 26.826 19.162 47.521 19.162 45.221 0 78.563-20.695 94.275-58.635 6.132 0 19.545 0 26.06-13.03l1.916-3.449.767-1.533-3.066-2.683z"
    />
  </svg>
)

Docker.href = 'https://docker.com'

export default Docker
